/** Window large chat histories for performance (plan §12). */

export const DEFAULT_WINDOW = 80;
export const WINDOW_STEP = 80;

export function visibleSlice<T>(items: T[], visibleCount: number): T[] {
  if (items.length <= visibleCount) return items;
  return items.slice(items.length - visibleCount);
}

export function nextWindow(current: number, total: number, step = WINDOW_STEP): number {
  return Math.min(total, current + step);
}
